const server = "https://shop.strackit.com/shop/web";
// const server = "http://localhost/sshop-backend/";


let Url = {

  strackitYou:'https://you.strackit.com/',
  strackShop: "https://you.strackit.com?redirectto=https://shop.strackit.com",
  sendOTP: "https://you.strackit.com/ALUMNI/loginandsignup/sendotp.php",
  verifyOTP: "https://you.strackit.com/ALUMNI/loginandsignup/verifyotp.php",
  redirectURL:"https://you.strackit.com?redirectto=https://shop.strackit.com",
  loginAndRedirectToPath:"https://you.strackit.com?redirectto=" + window.location.href,
  loginAndRedirectToOrigin:"https://you.strackit.com?redirectto=" + window.location.origin,
  redirect:"https://you.strackit.com?redirectto=",
  myOrders : "https://you.strackit.com?redirectto=https://shop.strackit.com/myorders",
  profile:'https://you.strackit.com/profile',

  businessURL : "https://business.strackit.com/",
  editProduct:"https://business.strackit.com/edit-product?id=",

  getShopByCategory: server + "/shop/getshopbycategorys.php",
  identicalProducts : server + '/shop/identicalproducts.php',
  getProductByshopName: server + '/shop/productsbycategory.php?shop=',
  
  getCart: server + '/cart/get.php',
  getCartByName: server + '/cart/getbyname.php',
  removeCartItem:server + '/cart/remove.php',

  addEnquiry:server + '/enquiry/add.php',

  search:server + '/product/search.php',
  searchProducts:server + '/product/searchproducts.php',
  checkQuantity:server + '/product/checkquantity.php',
  cartChange: server + '/product/cart.php',
  addCart: server + '/product/addcart.php',
  viewProduct: server + '/product/view.php',

  identicalShops: server + '/home/identicalshops.php',

  addAddress : server + '/address/add.php',
  getByShopName:server + '/address/getbyshopName.php',
  getShopAddressByName : server + '/address/getshopaddressbyname.php',
  getShopAddress: server + '/address/getshopaddress.php',
  deleteAddress: server + '/address/delete.php',
  editAddress: server + '/address/edit.php',
 
  getMyOrder:server + '/order/getmyorder.php',
  cancelOrder: server + '/order/cancel.php',
  getMyOrderDetail:server + '/order/getmyorderdetails.php',
  payAndconfirmByshopId:server + '/order/payandconformbyshopid.php',
  payAndconfirm:server + '/order/payandconform.php',

  postRating:server + '/ratingandreview/postrating.php',

  getAllPost:server+'/socialmedia/getallpost.php',
  getPostByshopName: server+'/socialmedia/getpostbyshopname.php',
};

export default Url;
